import React, { PropsWithChildren } from 'react'
import { selectIsAuthLoading } from '@meprism/shared/src/redux/authentication/authenticationSlice'
import { useAppSelector } from '../../redux/storeExports'
import { useNavigation } from 'react-router-dom'
import { Box } from '@mui/material'
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import Lottie from 'lottie-react'
import loaderJson from '@meprism/shared/src/assets/icons/loader.json'

export const AuthLoader = ({ children }: PropsWithChildren) => {
  const authLoading = useAppSelector(selectIsAuthLoading)
  const navigation = useNavigation()

  if (authLoading || navigation.state === 'loading') {
    return (
      <Box
        sx={{
          width: '100%',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <div style={{ width: 100, height: 100 }}><Lottie animationData={loaderJson} loop={true} /></div>
      </Box>
    )
  }

  return <>{children}</>
}
